module.exports = __webpack_public_path__ + "assets/img/bg-line-mecha-e0dee564.png";